import { PayloadAction, createReducer } from "@reduxjs/toolkit"

import { notify } from "./actions"
import type { NotifyPayload } from "./actions"

interface NotificationState {
  notification: NotifyPayload | null
}

const initialState: NotificationState = {
  notification: null,
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(notify, (state, action: PayloadAction<NotifyPayload>) => {
    state.notification = action.payload
  })
})

export default reducer
